import { Routes, Route, Link } from 'react-router-dom';
import About from './pages/About';
import ColdFlareStudios from './pages/ColdFlareStudios';
import ComingSoon from './pages/ComingSoon';
import Contact from './pages/Contact';
import DevLog from './pages/DevLog';
import Arcade from './pages/Arcade';
import CoinCollector from './html-games/CoinCollector';
import RockPaperScissors from './html-games/RockPaperScissors';
import DevLogPost from "./pages/DevLogPost";
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import "./App.css";

export default function App() {
  return (
    <div>
      <nav className='nav-bar'>
        <Link to="/" className='nav-bar-link'>Home</Link> | <Link to="/about" className='nav-bar-link'>About</Link> | <Link to="/coldflarestudios" className='nav-bar-link'>ColdFlare Studios</Link> | <Link to="/arcade" className='nav-bar-link'>Arcade</Link> | <Link to="/contacts" className='nav-bar-link'>Contact</Link>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/coldflarestudios" element={<ColdFlareStudios />} />
        <Route path="/arcade" element={<Arcade />} />
        <Route path="/coincollector" element={<CoinCollector />} />
        <Route path="/rockpaperscissors" element={<RockPaperScissors />} />
        <Route path="/contacts" element={<Contact />} />
        <Route path="/devlog" element={<DevLog />} />
        <Route path="/dev-log/:id" element={<DevLogPost />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}